import { Notification } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";

export const NotSelectedNotification: FunctionComponent = () => {
    const {
        singleMultipleCms: { pleaseSelect },
    } = usePropertySelectionViewModelValue();

    return (
        <Notification
            intent="error"
            title={pleaseSelect}
            asset={{
                id: "fill.symbol.triangle-exclamation",
            }}
        />
    );
};
